import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getFormLabelUtilityClass(slot) {
  return generateUtilityClass('JoyFormLabel', slot);
}
const formLabelClasses = generateUtilityClasses('JoyFormLabel', ['root', 'asterisk']);
export default formLabelClasses;